"use client";

import React, { useState } from "react";
import Modal from "Common/Components/Modal";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Plus } from "lucide-react";
import Select from "react-select";
import { useAppServices } from "hook/services";
import { useParams } from "react-router-dom";

interface propTypes {
  handleRefresh: any;
}


const FolderCreateModal = ({ handleRefresh }: propTypes) => {
  const AppService = useAppServices();
  const { locationId } = useParams();

  const [show, setShow] = useState<boolean>(false);
  const toggle = () => setShow((prev) => !prev);

  const handleSubmit = async (values: any) => {
    const payload = {
      ...values,
      locationId: locationId, // from user context
    };

    const { response, error } = await AppService.custom_value.folder.create({
      payload,
      toaster: true,
    });

    if (response) {
      formik.resetForm();
      toggle();
      handleRefresh();
    }
  };

  // ✅ Formik setup
  const formik = useFormik({
    initialValues: {
      name: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter field name"),
    }),
    onSubmit: (values) => handleSubmit(values),
  });

  return (
    <>
      <button
        type="button"
        className="text-white btn bg-custom-500 border-custom-500 hover:bg-custom-600 focus:ring focus:ring-custom-100"
        onClick={toggle}
      >
        <Plus className="inline-block size-4 mr-1" />
        <span className="align-middle">Add Folder</span>
      </button>

      <Modal
        show={show}
        onHide={toggle}
        id="folderModal"
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600"
      >
        <Modal.Header className="flex items-center justify-between p-4 border-b dark:border-zink-300/20">
          <Modal.Title className="text-16 font-semibold">
            Add Folder
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          <form onSubmit={formik.handleSubmit} className="space-y-4">
            {/* Name */}
            <div>
              <label className="block mb-1 text-sm font-medium">Name</label>
              <input
                type="text"
                name="name"
                placeholder="Enter field name"
                className="form-input w-full"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.name}
              />
              {formik.touched.name && formik.errors.name && (
                <p className="text-red-400 text-sm mt-1">
                  {formik.errors.name}
                </p>
              )}
            </div>


            {/* Actions */}
            <div className="flex justify-end gap-2 pt-2">
              <button
                type="button"
                className="text-red-500 bg-white border btn hover:text-red-600"
                onClick={() => {
                  formik.resetForm();
                  toggle();
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="text-white btn bg-custom-500 border-custom-500 hover:bg-custom-600"
              >
                Add Folder
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default FolderCreateModal;
